function isStandaloneMode() {
	const isStandaloneModeIOS = window && window.navigator && window.navigator.standalone;
	const isStandaloneModeAndroid = window && window.matchMedia && (window.matchMedia("(display-mode: standalone)").matches);

	return isStandaloneModeIOS || isStandaloneModeAndroid;
}

export default isStandaloneMode;



// WEBPACK FOOTER //
// ./src/shared/util/isStandaloneMode.js